module.exports = __webpack_public_path__ + "static/media/sensable_9.e8fc04cf.gif";